import { Bold, Italic, List, ListOrdered, Underline } from 'lucide-react';
import React, { useMemo } from 'react';
import type { SupportedFeatures, SupportedListNodeTagType, SupportedTextFormatType } from '../../../utils/features';

type ToolbarActions<T> = {
    label: string;
    style: T;
    icon: React.JSX.Element;
};

const allFormatStyles: ToolbarActions<SupportedTextFormatType>[] = [
    {
        label: 'Bold',
        style: 'bold',
        icon: <Bold className="h-4 w-4" />,
    },
    {
        label: 'Italic',
        style: 'italic',
        icon: <Italic className="h-4 w-4" />,
    },
    {
        label: 'Underline',
        style: 'underline',
        icon: <Underline className="h-4 w-4" />,
    },
];

const allListTypes: ToolbarActions<SupportedListNodeTagType>[] = [
    { label: 'Numbered list', style: 'ol', icon: <ListOrdered className="h-4 w-4" /> },
    { label: 'Bullet List', style: 'ul', icon: <List className="h-4 w-4" /> },
];

const useToggleActions = (features?: SupportedFeatures[]) => {
    const actions = useMemo(() => {
        const formats = allFormatStyles.filter((format) => features?.includes(format.style));
        const lists = allListTypes.filter((listType) => features?.includes(listType.style));

        return { formats, lists };
    }, [features]);

    return actions;
};

export default useToggleActions;
